import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { useViewer } from '@/entities/viewer';
import { SystemStatus } from '@/features/system-status';

import styles from './LandingFooter.module.css';
import { Logo } from './Logo';
import { SECTION_IDS } from './sections';

/** Brand, the page's sections, the account links and (quietly) the service status. */
export function LandingFooter() {
  const { t } = useTranslation();
  const viewer = useViewer();
  const signedIn = viewer.status === 'authenticated';
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandBlock}>
          <span className={styles.brand}>
            <Logo />
            {t('app.name')}
          </span>
          <p>{t('landing.footer.tagline')}</p>
        </div>
        <nav className={styles.column} aria-label={t('landing.footer.sections')}>
          <h2>{t('landing.footer.sections')}</h2>
          {SECTION_IDS.map((id) => (
            <a key={id} href={`#${id}`}>
              {t(`landing.nav.${id}`)}
            </a>
          ))}
        </nav>
        <nav className={styles.column} aria-label={t('landing.footer.account')}>
          <h2>{t('landing.footer.account')}</h2>
          {signedIn ? (
            <Link to="/app">{t('landing.cta.open')}</Link>
          ) : (
            <>
              <Link to="/login">{t('landing.cta.signIn')}</Link>
              <Link to="/register">{t('landing.cta.start')}</Link>
            </>
          )}
        </nav>
        <div className={styles.status} aria-label={t('landing.footer.status')}>
          <SystemStatus />
        </div>
      </div>
    </footer>
  );
}
